import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { computed } from 'vue'

  // Components
  import BasePaymentCondition from './BasePaymentCondition.vue'
  import TermsAndConditionsLink from '@/components/common/TermsAndConditionsLink.vue'

  // Translations
  import { useI18n } from 'vue-i18n'
  import FlexiblePaymentIcon from '@/assets/FlexiblePaymentIcon.vue'

  // Config
  import { isTravelskiExpress as checkIsTravelskiExpress } from '@/config'
  import { TRAVELSKI_EXPRESS_TERMS_URL } from '@/config/termsAndConditions'

  // Props
  interface Props {
    cancellationUntil: string | null
    prestId: number
    liheId: number
    liheName?: string
    packageCode?: string
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'FlexiblePaymentCondition',
  props: {
    cancellationUntil: {},
    prestId: {},
    liheId: {},
    liheName: {},
    packageCode: {}
  },
  setup(__props: any) {

  // Vue
  const { t, d } = useI18n()

  // Icons
  const props = __props

  // Check if this is a Travelski Express booking
  const isTravelskiExpress = computed(() => {
    return checkIsTravelskiExpress(props.liheId, props.liheName, props.packageCode)
  })

  // Computed description text
  const descriptionText = computed(() => {
    if (props.cancellationUntil) {
      return t('payments.flexDescription', {
        cancellationUntil: d(props.cancellationUntil),
      })
    }
    // Fallback when no cancellation date - show description without date
    const fullDescription = t('payments.flexDescription', { cancellationUntil: '' })
    // Remove "until [date]" part from translations that require it
    return fullDescription
      .replace(/\s*until\s*/i, '')
      .replace(/\s*jusqu'?au\s*/i, '')
      .replace(/\s*tot\s*/i, '')
      .trim()
  })

return (_ctx: any,_cache: any) => {
  return (isTravelskiExpress.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(TermsAndConditionsLink, {
          linkText: _unref(t)('payments.termsAndConditions'),
          "custom-url": _unref(TRAVELSKI_EXPRESS_TERMS_URL)
        }, null, 8, ["linkText", "custom-url"])
      ]))
    : (_openBlock(), _createBlock(BasePaymentCondition, {
        key: 1,
        "border-class": "blue-border",
        "text-class": "text-primary-white",
        "background-class": "bg-primary-blue"
      }, {
        "payment-condition-icon": _withCtx(() => [
          _createVNode(FlexiblePaymentIcon)
        ]),
        "payment-condition-type": _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('payments.flexProduct')), 1)
        ]),
        "payment-condition__title__ref": _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('payments.flexTitle')), 1)
        ]),
        "payment-condition-description": _withCtx(() => [
          _createTextVNode(_toDisplayString(descriptionText.value) + " ", 1),
          _createVNode(TermsAndConditionsLink, {
            linkText: _unref(t)('payments.termsAndConditions')
          }, null, 8, ["linkText"])
        ]),
        _: 1
      }))
}
}

})